import type { FreelancerFillInformationPageLocales } from '../types';

const freelancerFillInformationPageLocales: FreelancerFillInformationPageLocales =
  {
    checkboxMyself: 'I am submitting this application as myself',
    checkboxTermsAndConditions1: 'I have read ',
    checkboxTermsAndConditions2: ' and I agree with this',
    checkboxTruthfully: 'I have entered my application truthfully',
    diplomasStep: 'Diploma & Certificates',
    documentsStep: 'Documents',
    headline:
      'Once you have completed all the steps, you can submit your application. If you still want to change data, do so now.',
    headlineCompleted:
      'Congratulations on completing your application. Can you tell us if the following statements are in line with your application?',
    kvkInformationStep: 'KVK Information',
    personalInformationStep: 'Personal Information',
    stepCompleted: 'Completed',
    stepNonCompleted: 'Not Completed',
    submitApplication: 'Submit Application',
    termsAndConditions: 'Terms and Conditions',
    title: 'Sign Up',
  };

export default freelancerFillInformationPageLocales;
